import Vue from 'vue'

// Shared fallback for legacy page lists that have no local loading state.
// Key by route so a previous page's request cannot affect the current page.
export const listRequestState = Vue.observable({ routes: {} })

export function beginListRequest (config, route) {
  if (!route || config.notShowLoading || (config.method || 'get').toLowerCase() !== 'get') return
  let state = listRequestState.routes[route]
  if (!state) {
    state = { pending: 0, failed: false }
    Vue.set(listRequestState.routes, route, state)
  }
  if (!state.pending) state.failed = false
  state.pending++
  config.listRequestRoute = route
}

export function finishListRequest (config, failed = false) {
  if (!config || !config.listRequestRoute) return
  const route = config.listRequestRoute
  delete config.listRequestRoute
  // Let the caller apply its response data before revealing the empty slot.
  setTimeout(() => {
    const state = listRequestState.routes[route]
    if (!state) return
    if (failed) state.failed = true
    state.pending = Math.max(0, state.pending - 1)
  }, 0)
}



// WEBPACK FOOTER //
// ./src/utils/listRequestState.js